import { FlexBox, Icon, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { analytics } from 'segment_analytics'
import { useStats } from '../../../lib/ctx/stats'
import { updateUserStats } from '../../../lib/requests'
import { useStatsTheme } from '../../../theme/ctx'
import { StatsThemeId } from '../../../theme'

export const StatsThemeSelector = () => {
  const { colors } = useTheme()
  const stats = useStats((s) => s.stats)
  const [themes, setTheme, currentTheme] = useStatsTheme((s) => [
    s.enabledThemes,
    s.setTheme,
    s.currentTheme,
  ])

  const handleSelectTheme = async (id: StatsThemeId) => {
    try {
      analytics.events.stats.statsThemeChanged({ theme_color: id })
      setTheme(id)

      await updateUserStats({
        userId: stats?.user?.id || '',
        statsId: stats?.id || '',
        data: { theme: id },
      })
    } catch (e) {
      console.error('Error updating user stats theme', e)
    }
  }

  return (
    <div>
      <Text
        className={css`
          padding: 0 12px;
        `}
        type="label"
        sizing="L"
        color={colors.uiPewterGrey}
      >
        Choose your theme
      </Text>
      <ul
        className={css`
          margin-top: 5px;
        `}
      >
        {themes.map((theme) => {
          const id = theme.id
          const selected = currentTheme === id

          return (
            <li
              key={id}
              data-testid={`stats-theme-selector-${id}`}
              className={css`
                padding: 0 20px 0 12px;
                cursor: pointer;
              `}
              onClick={(e) => {
                e.stopPropagation()
                handleSelectTheme(id)
              }}
            >
              {theme.isNew ? (
                <FlexBox
                  className={css`
                    margin-bottom: -2px;
                    background-color: ${colors.uiPewterGrey};
                    border-radius: 10px;
                    width: 27px;
                    height: 11px;
                  `}
                  centerAll
                >
                  <Text
                    type="label"
                    color={colors.uiWhite}
                    weight="500"
                    custom={{ fontSize: '7px', lineHeight: '7px' }}
                  >
                    NEW
                  </Text>
                </FlexBox>
              ) : null}
              <FlexBox
                className={css`
                  height: 32px;
                  display: flex;
                  align-items: center;
                  cursor: pointer;
                `}
              >
                <FlexBox
                  className={css`
                    width: 100%;
                  `}
                  as="span"
                  alignItems="center"
                  gap="8px"
                >
                  <span
                    className={css`
                      display: block;
                      width: 8px;
                      height: 8px;
                      background-color: ${theme.colors.menuDot};
                      border-radius: 50%;
                    `}
                  />
                  <Text type="body" sizing="M" color={colors.uiWhite}>
                    {theme.name}
                  </Text>
                </FlexBox>
                <Icon
                  className={css`
                    flex-shrink: 0;
                    opacity: ${selected ? 1 : 0};
                  `}
                  type="tick"
                  fill={colors.uiWhite}
                />
              </FlexBox>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
